import { render, staticRenderFns } from "./ResidencyProof.vue?vue&type=template&id=e577cf82&scoped=true"
import script from "./ResidencyProof.vue?vue&type=script&lang=js"
export * from "./ResidencyProof.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e577cf82",
  null
  
)

export default component.exports